import conf from '../../conf';
import fetch from '../fetch';

import { receiveEconomicNexusThresholds } from '../../store/economic-nexus';
import { getWindowQueryUnlessInProd } from '../helpers';

import type { Dispatch } from '@avalara/types/actions';
import type { EconomicThreshold } from '@avalara/types/economic-nexus';

const noResults = {
  exceedingThreshold: [],
  approachingThreshold: [],
};

export const getEconomicThresholdStates = () => async (dispatch: Dispatch) => {
  const postParams = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const query = getWindowQueryUnlessInProd();
  const result = await fetch(dispatch)<Array<EconomicThreshold>>(
    `${conf.API_URL}/api/economic-nexus${query}`,
    postParams,
  );

  if (!result.ok) {
    dispatch(receiveEconomicNexusThresholds(noResults));
    return;
  }

  const economicNexusThresholds = result.value;
  if (!economicNexusThresholds.length) {
    dispatch(receiveEconomicNexusThresholds(noResults));
    return;
  }

  const exceedingThreshold = [
    ...new Set(
      economicNexusThresholds
        .filter((threshold) => threshold.ThresholdMet === 'Met')
        .map((threshold) => threshold.StateName.toLowerCase())
        .sort(),
    ),
  ];

  const approachingThreshold = [
    ...new Set(
      economicNexusThresholds
        .filter((threshold) => threshold.ThresholdMet === 'Approaching')
        .map((threshold) => threshold.StateName.toLowerCase())
        .sort(),
    ),
  ];

  const economicThresholdStates = {
    exceedingThreshold,
    approachingThreshold,
  };

  dispatch(receiveEconomicNexusThresholds(economicThresholdStates));
};
